import { ReactNode } from 'react';
import styled from 'styled-components';

interface WrapperProps {
  children?: ReactNode;
  onClick?: any;
}

export const Wrapper = styled.div<WrapperProps>`
  width: 100%;
`;

interface FileInputProps {
  type?: string;
  accept?: string;
  multiple?: boolean;
  onChange?: any;
  ref?: any;
  name?: string;
}

export const FileInput = styled.input<FileInputProps>`
  display: none;
`;
